import { render, staticRenderFns } from "./FormTableCertificateSelect.vue?vue&type=template&id=aea10f34&scoped=true&"
import script from "./FormTableCertificateSelect.vue?vue&type=script&lang=js&"
export * from "./FormTableCertificateSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea10f34",
  null
  
)

export default component.exports